import { SyncState } from "../store.types";
import rootSelector from "./root.selector";

const getAccountInfoState = rootSelector.accountInfo;

export const accountInfoSelector = {
    accountId(state: SyncState): string | undefined {
        return getAccountInfoState(state).accountId;
    }
}